// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import axios from "axios";
import { store } from "@/store";
import * as types from "@/utils/Types";

/**
 * Sends code to the backend to run
 * @param AST The parsed code, level id and bundle id
 * @returns Instructions to visualise in the game loop
 */
async function runLevel(AST: types.AST): Promise<types.instructions | null> {
  try {
    let res;
    if (AST.bundleId != null) {
      res = await axios.post<string | types.instructions>(
        `/World/Run/${AST.bundleId}/${AST.levelId}`,
        AST.compiledCode,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    } else {
      res = await axios.post<string | types.instructions>(
        `/World/RunTest/${AST.levelId}`,
        AST.compiledCode,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    }

    return res.data as types.instructions;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Saves the code currently in the editor
 * @param progress The code currently written by the user, bundleId and levelId in one
 * @returns the statuscode of the request
 */
async function saveGameProgress(
  progress: types.levelSave
): Promise<number | null> {
  try {
    const res = await axios.post<string>(
      `/World/Save/${progress.bundleId}/${progress.levelId}`,
      progress.code,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    return res.status;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets all available world names
 * @returns All available world names
 */
async function getWorldNames(): Promise<string[] | null> {
  try {
    const res = await axios.get<string[]>(`/World/Names/`);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets all available world variables and functions of a given world
 * @param worldName The world to get the types from
 * @returns All available world types in the given world
 */
async function getWorldData(
  worldName: string
): Promise<types.worldData | null> {
  try {
    const res = await axios.get<types.worldData>(
      `/World/Types?worldName=${worldName}`
    );
    console.log("WORLD DATA", res);
    store.commit("setWorldData", res.data);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export { runLevel, saveGameProgress, getWorldNames, getWorldData };
